import api from "@/lib/axiosConfig";
import { LayoutNonNullable } from "@/lib/cms/section-types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const baseUrl = "back/api/cms/selection";

const getLayout = async () => {
  const response = await api.get<LayoutNonNullable>(baseUrl + "/layout");
  return response.data;
};
export const useGetLayout = () => {
  return useQuery({
    queryKey: ["cms", "layout"],
    queryFn: getLayout,
  });
};

const updateLayout = async (layout: LayoutNonNullable) => {
  const response = await api.patch<LayoutNonNullable>(
    baseUrl + "/layout",
    layout,
  );
  return response.data;
};
export const useUpdateLayout = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateLayout,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cms", "layout"] });
    },
  });
};
